(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-list-item"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll('.accordion-checkbox');

    accordions.forEach((accordion) => {
      accordion.addEventListener('change', function() {
        const content = this.parentElement.querySelector('.tab__content');
        const video = content.querySelector('video');

        if (this.checked) {
          // Close all other accordions
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== this) {
              otherAccordion.checked = false;
              const otherContent = otherAccordion.parentElement.querySelector('.tab__content');
              const otherVideo = otherContent.querySelector('video');
              otherContent.style.maxHeight = 0;

              // Pause the video in the other accordion if it exists
              if (otherVideo) {
                otherVideo.pause();
              }
            }
          });
          // Open the current accordion
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          // Close the current accordion
          content.style.maxHeight = 0;

          // Pause the video in the current accordion if it exists
          if (video) {
            video.pause();
          }
        }
      });
    });

    // Initialize correct maxHeight on page load
    accordions.forEach((accordion) => {
      const content = accordion.parentElement.querySelector('.tab__content');
      const video = content.querySelector('video');
      if (accordion.checked) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = 0;

        // Pause the video if accordion is closed on page load
        if (video) {
          video.pause();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-countdown"] && !window.DesignMode) return;
  try {
    
//Countdown Timer 
const cend = new Date("December 2, 2024 23:59:59").getTime();
//const cend = new Date({{section.settings.countdowndate}}).getTime();
const cdayEl = document.getElementById('cdays');
const choursEl = document.getElementById('chours');
const cminutesEl = document.getElementById('cminutes');
const csecondsEl = document.getElementById('cseconds');
const cseconds = 1000;
const cminutes = cseconds * 60;
const chours = cminutes * 60;
const cdays = chours * 24;

const c = setInterval(function () {
  let cnow = new Date().getTime();
  const difference = cend - cnow;
  
  if (difference < 0) {
    clearInterval(c);
    document.getElementById("cdone").innerHTML = "Sorry, this sale ended.";
    return;
  }
    
  cdayEl.innerText = Math.floor(difference / cdays);
  choursEl.innerText = Math.floor( (difference % cdays) / chours );
  cminutesEl.innerText = Math.floor( (difference % chours) / cminutes );
  csecondsEl.innerText = Math.floor( (difference % cminutes) / cseconds );  
}, cseconds);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuffle-spotlight-carousel"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  let currentCardIndex = 0;
  const cards = $('.we-card');
  const totalCards = cards.length;

  let currentInfoIndex = 0;
  const infos = $('.we-text');
  const totalInfos = infos.length;

  function updateCarousel() {
    cards.removeClass('active prev-1 next-1 prev-2 next-2 prev-3 next-3');
    $(cards[currentCardIndex]).addClass('active');

    infos.removeClass('text_active');
    $(infos[currentInfoIndex]).addClass('text_active');

    const prevIndex_1 = (currentCardIndex - 1 + totalCards) % totalCards;
    const nextIndex_1 = (currentCardIndex + 1) % totalCards;
    const prevIndex_2 = (currentCardIndex - 2 + totalCards) % totalCards;
    const nextIndex_2 = (currentCardIndex + 2) % totalCards;
    const prevIndex_3 = (currentCardIndex - 3 + totalCards) % totalCards;
    const nextIndex_3 = (currentCardIndex + 3) % totalCards;

    $(cards[prevIndex_1]).addClass('prev-1');
    $(cards[nextIndex_1]).addClass('next-1');
    $(cards[prevIndex_2]).addClass('prev-2');
    $(cards[nextIndex_2]).addClass('next-2');
    $(cards[prevIndex_3]).addClass('prev-3');
    $(cards[nextIndex_3]).addClass('next-3');
  }

  updateCarousel();

  $('.right').click(function () {
    currentCardIndex = (currentCardIndex + 1) % totalCards;
    currentInfoIndex = (currentInfoIndex + 1) % totalInfos;    
    updateCarousel();
  });

  $('.left').click(function () {
    currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
    currentInfoIndex = (currentInfoIndex - 1 + totalInfos) % totalInfos;    
    updateCarousel();
  });
});


  } catch(e) { console.error(e); }
})();
})();
